module.exports = __webpack_public_path__ + "static/media/acceptplan.10f0b409.PNG";